<script setup lang="ts">
import { computed, useTemplateRef } from 'vue'
import { useElementSize } from '@vueuse/core'
import NavBar from '@/components/navbar/NavBar.vue'
import SubNavigation from '@/components/navbar/SubNavigation.vue'
import { useAuthStore } from '@/stores/auth.store'
import { storeToRefs } from 'pinia'
import NavigationFooter from '@/components/NavigationFooter.vue'
import EmailVerificationBanner from '@/components/ui/EmailVerificationBanner.vue'
import { useRoute } from 'vue-router'

const authStore = useAuthStore()
const { user } = storeToRefs(authStore)
const isReviewer = computed(() => authStore.isReviewer)

const route = useRoute()
const navigation = useTemplateRef<HTMLElement>('navigation')
const { height: navigationHeight } = useElementSize(navigation, undefined, { box: 'border-box' })
</script>
<template>
    <div class="main-layout flex flex-col md:min-h-screen min-h-full">
        <div ref="navigation" class="sticky top-0 z-50 shrink-0">
            <NavBar :hide-nav-items="isReviewer" />
            <SubNavigation
                v-if="user && !route.meta.disableSubNavigation && !isReviewer"
                data-testid="main-layout-sub-navigation-user"
            />
            <EmailVerificationBanner
                v-if="user && !user.emailVerifiedAt"
                data-testid="email-verification-banner"
            />
        </div>
        <div class="layout-content relative z-0 flex min-h-0 flex-1 flex-col">
            <router-view class="flex-1 min-h-0" />
            <NavigationFooter v-if="!route.meta.disableFooter" :bottom-only="isReviewer" />
        </div>
    </div>
</template>

<style scoped>
.main-layout {
    --navigation-height: v-bind('navigationHeight + "px"');
}

.layout-content :deep(:is(.sticky, [class*=':sticky'])) {
    top: calc(var(--navigation-height) + 1.25rem);
}
</style>
